import { observer } from 'mobx-react';
import { emptyFragment } from '@execonline-inc/execonline-ui';
import { ExperienceResource } from '../../../../../Experience/Types';
import {
  ProgramEnrolled,
  ProgramGraduated,
  ProgramOverviewItems,
} from '../../../../../Experience/ExperienceBody';
import { getPrimaryCompetencies } from '../../../../../Experience/ExperienceCompetencies';

interface Props {
  experienceResource: ExperienceResource;
}

function LearningJourneyOverview({ experienceResource }: Props) {
  switch (experienceResource.payload.kind) {
    case 'commerce-enrollable':
    case 'enrollable':
    case 'not-enrollable':
    case 'not-licensed': {
      const competencies = getPrimaryCompetencies(experienceResource);

      return (
        <ProgramOverviewItems competencies={competencies} experience={experienceResource.payload} />
      );
    }
    case 'beginnable':
    case 'resumable':
      return <ProgramEnrolled />;
    case 'graduated':
    case 'returnable':
      return <ProgramGraduated />;
    case 'upcoming':
      return emptyFragment();
  }
}

export default observer(LearningJourneyOverview);
